<template>
	<div class="portrait" :class="hero.slug">
		<div class="illustration">
			<div class="img" v-bg="'cards/hero/' + hero.slug + '-idle.png'"></div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'portrait',
	props: {
		hero: { default: null }
	},
	computed: {
		...mapGetters([ 'lang' ])
	}
}
</script>

<style lang="stylus" scoped>

.portrait
	height 100%
	flex center center
	font-size 4rem
	width 120px
	height 120px
	border-radius 50%
	background-color #FFEFD9
	&:after
		content ''
		absolute -1px
		border 4px solid dark
		border-radius 50%
	&.fish .illustration .img
		background-position 80% 8px
		background-size 200px auto
	&.carrot .illustration .img
		background-position 65% -48px
		background-size 180px auto
	&.barrel .illustration .img
		background-position 60% 8px
		background-size 250px auto
	&.spider .illustration .img
		background-position 45% -28px
		background-size 250px auto
	&.wolf .illustration .img
		background-position 100% -20px
		background-size 350px auto
	.illustration
		absolute 0
		border-radius 50%
		overflow hidden
		.img
			absolute 0
			background top center no-repeat
			background-size 150% auto

</style>
